import BaseIdObject from "@shared/BaseIdObject";
import {Type} from "@qwoach/class-transformer-wrapper";
import TagItem from "@shared/Tags/TagItem";

export default class SessionPlanAnswerItem extends BaseIdObject {
	content: string = null

	@Type(() => TagItem)
	tags: TagItem[] = []

	constructor(options = {}) {
		super(options)
		this.applyOptions(options)
	}
}
